import { ModelBase } from "../ModelBase.js";

export class OverlayBase extends ModelBase {
    /**
     * Coordinates of top left corner of image
     * @type {{lat: Number, lng: Number}}
     */
    location = { lat: 0, lng: 0 };

    get topLeft() {
        return this.location;
    }
    set topLeft(v) {
        this.location = v;
    }
    /**
     * Width and height in degrees. long is width and lat is height if north is up
     * @type {{lng: number, lat: number}}
     */
    get dimensions() {
        return {
            lat: Math.abs(this.botRight.lat - this.topLeft.lat),
            lng: Math.abs(this.botRight.lng - this.topLeft.lng),
        };
    }

    /**
     * Bottom right corner of image
     * @return {{lat: Number, lng: Number}}
     */
    botRight = { lat: 0, lng: 0 };

    /**
     * the type of overlay
     * @type {"NDVI" | "Network"}
     */
    type = "NDVI";

    /**
     * The date at which the data was collected
     * @type {number}
     */
    date = Date.now();

    /**
     * URL of the overlay image
     * @type {string}
     */
    imageURL;

    /**
     * Downsized image url
     * @type {string}
     */
    previewImageURL;

    /**
     * NOT FUNCTIONAL FOR OVERLAYS AT THIS TIME!
     * @constructor
     */
    static async createNew() {
        // await APICommands.zones.addOne(vertices, label).then((r)=>{
        //     return new Zone(r);
        // })
    }
    category = "overlay";
    constructor(json) {
        super(json);
        if (json.topLeft) {
            this.topLeft = json.topLeft;
            this.topLeft.lng = json.topLeft.lng || json.topLeft.long;
            this.topLeft.long = json.topLeft.lng || json.topLeft.long;
        }
        if (json.botRight) {
            this.botRight = json.botRight;
            this.botRight.lng = json.botRight.lng || json.botRight.long;
            this.botRight.long = json.botRight.lng || json.botRight.long;
        }
        this.imageURL = json.img_url;
        try {
            if (json.date) {
                this.date = new Date(json.date);
            }
            this.dbID = json._id;
        } catch (e) {}
    }
    /**
     * Deletes this entity and returns when the entity has been deleted from the server.
     */
    async delete() {
        return await super.delete();
    }

    /**
     *
     * @return {Promise<void>}
     */
    async edit() {
        return await super.edit();
    }
}
